var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_2413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1717 20.1495C15.8655 21.9314 12.9593 22.752 10.0617 22.4393C7.16411 22.1267 4.49993 20.7051 2.62692 18.4722C-1.06314 14.0457 -0.863196 7.54517 3.21041 3.40163C7.28402 -0.741913 13.7714 -1.12873 18.2439 2.41819C20.5693 4.279 22.0685 6.98053 22.4174 9.93831C22.7663 12.8961 21.9367 15.8723 20.108 18.2231C20.2031 18.2648 20.2924 18.3188 20.3735 18.3837C22.7461 20.7498 25.1166 23.1173 27.4848 25.4863C27.8804 25.8819 28.0727 26.3353 27.935 26.8948C27.8803 27.1262 27.7672 27.3397 27.6065 27.5148C27.4457 27.69 27.2427 27.821 27.0169 27.8953C26.7911 27.9696 26.55 27.9848 26.3167 27.9393C26.0833 27.8939 25.8655 27.7893 25.6841 27.6357C25.5748 27.5439 25.4721 27.4368 25.3694 27.3341L18.3575 20.3233C18.3007 20.2687 18.2406 20.2151 18.1717 20.1495ZM2.79627 11.2364C2.78097 15.8836 6.57483 19.6917 11.2429 19.7146C15.8934 19.7376 19.707 15.9404 19.7234 11.2735C19.7249 9.03061 18.8368 6.87869 17.254 5.28956C15.6713 3.70043 13.5229 2.80381 11.28 2.79629C9.03779 2.79712 6.88702 3.6852 5.29744 5.26659C3.70786 6.84798 2.80869 8.99417 2.79627 11.2364Z",
    fill: "#259F64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_2413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9798,
    height: 27.97,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6ca3f2b7d74563e094c59eb9bbe6a62e.svg";
export { ForwardRef as ReactComponent };